import React from 'react';
import styled from 'styled-components';
import { Checkbox, FormControl, FormControlLabel } from '@mui/material';

const ErrorWrapper = styled.div`
	span {
		color: ${(props) => props.theme.error};
		font-size: 1.3rem;
	}
`;

export const CheckboxField = ({
	error,
	label,
	disabled = false,
	required = false,
	name,
	checked,
	value,
	onChange,
}) => {
	const renderError = () => {
		if (!error) {
			return <></>;
		}

		return <ErrorWrapper>{error}</ErrorWrapper>;
	};

	return (
		<>
			<FormControl fullWidth required={required}>
				<FormControlLabel
					control={
						<Checkbox
							value={value}
							name={name}
							checked={checked}
							tabIndex={-1}
							disableRipple
							disabled={disabled}
							onChange={(_, isChecked) => onChange(isChecked, name)}
						/>
					}
					label={<span dangerouslySetInnerHTML={{ __html: label }} />}
				/>
			</FormControl>
			{renderError()}
		</>
	);
};
